import firestore from '../firestore'

export default {
	setUsername({ commit }, username) {
		commit('setUsername', username)
	},
	getRoomData({ commit }) {
		let isFirstRoomDataSet = false
		let timeUntilSetFirstRoomData = Date.now() + 2000
		let firstRoomDataSetTimer;

		firestore.getRoomDataDocument().onSnapshot(doc => {
			let roomData = doc.data()

			if (!isFirstRoomDataSet) {
				clearTimeout(firstRoomDataSetTimer)

				firstRoomDataSetTimer = setTimeout(() => {
					isFirstRoomDataSet = true
					commit('setRoomData', roomData)
				}, timeUntilSetFirstRoomData - Date.now())
			} else {
				commit('setRoomData', roomData)

			}
		})

		firestore.getRoomPlayersCollection().onSnapshot(snapshot => {
			commit('setRoomPlayers', snapshot.docs.map(doc => doc.data()))
		})

		firestore.getRoomVotesCollection().onSnapshot(snapshot => {
			commit('setRoomVotes', snapshot.docs.map(doc => doc.data()))
		})
	},
	async createRoom({ state }) {
		await firestore.resetRoomData()
		await firestore.addPlayerToRoom({ username: state.username, isLeader: true })
	},
	async recreateRoom() {
		await firestore.setRoomToPlayAgain()
	},
	async joinRoom({ state }) {
		await firestore.addPlayerToRoom({ username: state.username, isLeader: false })
	},
	async leaveRoom({ state }) {
		await firestore.removePlayerFromRoom(state.username)
	},
	async runRoom() {
		await firestore.generateRoles()
	},
	async vote({ state }, player) {
		await firestore.handleVote(state.username, player)
	},
	async setMafiaSuccess({ state }, isSuccessful) {
		await firestore.setMafiaSuccess(state.username, isSuccessful)
	}
}
